import { lazy } from 'react';

const Calculator = lazy(() => import('./Calculator'));

export default Calculator;
